import { useEffect, useRef } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { PairingPageWidget } from '@features/game/pages/PairingLobbyPage';
import { POOLS } from '@features/game/types/fast-game';

const querySchema = z.object({
  select: z.enum(POOLS).optional().catch(undefined),
});

export const Route = createFileRoute('/game/pairing/')({
  component: Page,
  validateSearch: querySchema,
});

function Page() {
  const { select } = Route.useSearch();
  const initialRef = useRef(select);
  const navigate = useNavigate();
  useEffect(() => {
    if (initialRef.current !== undefined) {
      navigate({ to: '/game/pairing', replace: true, search: {} });
    }
  }, [navigate]);
  return <PairingPageWidget initialPool={initialRef.current} />;
}
